module.exports = __webpack_public_path__ + "static/media/03.164ac2d8.jpg";